import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { BoxModule } from '../../../../../apex/src/app/components/box/box.module';
import { t } from '../../../../../apex/src/app/components/translate/translate.function';
import { TranslateModule } from '../../../../../apex/src/app/components/translate/translate.module';
import { UserConsent } from '../../../../../apex/src/app/features/user-consent/models/user-consent.model';
import { UserConsentService } from '../../../../../apex/src/app/features/user-consent/services/user-consent.service';
import { snack, snackErr } from '../../../../../apex/src/app/modules/snack.module';

@Component({
  selector: 'portal-apartment-user-consents',
  templateUrl: './apartment-user-consents.component.html',
  standalone: true,
  imports: [CommonModule, TranslateModule, BoxModule, MatSlideToggleModule],
})
export class ApartmentUserConsentsComponent implements OnInit {
  userConsents: UserConsent[] = [];
  userConsented: Record<string, boolean> = {};
  userConsentedToAll: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private userConsentService: UserConsentService,
  ) {}

  ngOnInit(): void {
    this.userConsents = this.route.snapshot.data['userConsents'] ?? [];

    for (const consent of this.userConsents) {
      this.userConsented[consent.id] = consent.UserConsentConsents?.length > 0;
    }

    this.calculateUserConsentedToAll();
  }

  calculateUserConsentedToAll(): void {
    this.userConsentedToAll = this.userConsents.every((consent) => this.userConsented[consent.id] === true);
  }

  async onChangeConsent(userConsent: UserConsent, consented: boolean): Promise<void> {
    try {
      if (consented) {
        await firstValueFrom(this.userConsentService.setConsent(userConsent.id));
      } else {
        await firstValueFrom(this.userConsentService.deleteConsent(userConsent.id));
      }

      this.userConsented[userConsent.id] = consented;
      this.calculateUserConsentedToAll();

      snack(t('User consent updated successfully'));
    } catch (error) {
      this.userConsented[userConsent.id] = !consented;

      snackErr(t('Could not save consent'), error);
    }
  }
}
